// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oIe0","type":"styles_type__2VLL1","choices":"styles_choices__10KS-"};